import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Campaign {
    id: number;
    name: string;
    sentDate: string;
    openRate: number;
    clickRate: number;
    totalRecipients: number;
}

interface CampaignState {
    campaigns: Campaign[];
    loading: boolean;
    error: string | null;
}

const initialState: CampaignState = {
    campaigns: [],
    loading: false,
    error: null
};

const campaignSlice = createSlice({
    name: 'campaign',
    initialState,
    reducers: {
        setCampaigns: (state, action: PayloadAction<Campaign[]>) => {
            state.campaigns = action.payload;
        },
        addCampaign: (state, action: PayloadAction<Campaign>) => {
            state.campaigns.push(action.payload);
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        }
    }
});

export const { setCampaigns, addCampaign, setLoading, setError } = campaignSlice.actions;
export default campaignSlice.reducer; 